import { ShowCustomToast, toaster } from "@packages/ui/components";
import {
  TOAST_ERROR,
  TOAST_INFO,
  TOAST_SUCCESS,
  TOAST_WARNING,
} from "@public/index";
import Image from "next/image";

type options = "success" | "error" | "info" | "warning";
interface toastOptions {
  type?: options;
  className?: string;
  position?: string;
}

export const toast = (
  message: string,
  options?: toastOptions,
  actionButtonText?: string,
  onAction?: () => void
) => {
  const getToastIcon = () => {
    if (options?.type === "success") {
      return <Image src={TOAST_SUCCESS} alt="Error" />;
    }
    if (options?.type === "error") {
      return <Image src={TOAST_ERROR} alt="Error" />;
    }
    if (options?.type === "info") {
      return <Image src={TOAST_INFO} alt="Info" />;
    }
    if (options?.type === "warning") {
      return <Image src={TOAST_WARNING} alt="Warning" />;
    }
    return null;
  };
  const img = getToastIcon();
  ShowCustomToast({
    data: { title: message },
    autoClose: 3000,
    type: options?.type || "success",
    actionButtonText,
    onAction,
  });

  // toaster(message, options, img);
};

export const priceFormatter = Intl.NumberFormat("en", { notation: "compact" });
export const priceFormatter2decimal = Intl.NumberFormat("en", {
  notation: "compact",
  minimumFractionDigits: 0, // Change it back if absolutely Required.
  maximumFractionDigits: 2,
});
